module.exports = __webpack_public_path__ + "static/users-ad7212b54b95173b11081e00ea8b3b3a.png";